import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddPayGatePaymentSettingsForm from './AddPayGatePaymentSettingsForm';

export type PayGatePaymentSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const PayGatePaymentSettingsDrawer = ({ onClose, visible, moduleId }: PayGatePaymentSettingsDrawerProps) => {
    const { t } = useTranslation(['paygatePaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('paygatePaymentModuleDetails:paymentSettingsDrawer.cancelButton')}
                    </Button>
                    <Button form="addPayGatePaymentSettings" htmlType="submit" type="primary">
                        {t('paygatePaymentModuleDetails:paymentSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('paygatePaymentModuleDetails:paymentSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddPayGatePaymentSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default PayGatePaymentSettingsDrawer;

export const usePayGatePaymentSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <PayGatePaymentSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
